module.exports = __webpack_public_path__ + "media/following.1b32a8ce.webm";